/**
 * Default duration the client pins requests to the primary region after writes.
 *
 * This constant is used to determine client behaviors as well as configure alarms to monitor for regressions.
 *
 * We want to keep this low to optimize performance while high enough to avoid any consistency errors.
 */
const API_PIN_DURATION = 2_500;
export default API_PIN_DURATION;
